<template>
  <div>
	<v-btn
		class="reloadButton"
		color="black"
		outlined
		@click="getFileListFromServer($keycloak.userName)"
		><v-icon>mdi-refresh</v-icon>
			{{txt.btn.refresh}}
	</v-btn>
	<v-alert
		class="messageFileFetching"
		type="info"
		color='green'
		v-show="showDownloadMessage">{{txt.downloadMessage}}
	</v-alert>
	<v-progress-linear
		class="progressbarFileList"
		indeterminate
		color="rgb(0, 160, 227)"
		v-show="showDownloadMessage"
	></v-progress-linear>
	<v-alert type="error" v-show="showDownloadError">{{txt.downloadError}}</v-alert>
	<v-list rounded>
		<v-subheader>{{txt.reports.toUpperCase()}}</v-subheader>
		<v-list-item-group
			v-model="selectedItem"
			color="primary"
		>
			<v-list-item
			v-for="(item, i) in fileList"
			:key="i"
			>
			<v-list-item-icon>
				<v-icon>mdi-file</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title v-text="item.filename"></v-list-item-title>
				<v-list-item-subtitle v-text="item.fileSize"></v-list-item-subtitle>
				<v-list-item-subtitle v-text="item.fileCreatedAt"/>
			</v-list-item-content>
			<v-list-item-action>
				<v-btn
					:disabled="showDownloadMessage"
					icon
					@click="downloadFile(item)">
					<v-icon color="grey lighten-1">mdi-download</v-icon>
				</v-btn>
				</v-list-item-action>
				<v-list-item-action>
				<v-btn
					:disabled="showDownloadMessage"
					icon
					@click="deleteFile(item)">
					<v-icon color="grey lighten-1">mdi-delete</v-icon>
				</v-btn>
				</v-list-item-action>
			</v-list-item>
		</v-list-item-group>
	</v-list>
	<v-card style="position:fixed;bottom:2%;width:100%">
		<h5>{{txt.noteFileLifetime}}</h5>
	</v-card>
	<v-dialog
		v-model="dialogConfirmDeleteFile"
		max-width="500"
	>
	<v-card>
		<div class="formEdit">
		<h3>{{txt.deleteConfirmation}} {{ fileSelectedForDelete ? fileSelectedForDelete.filename : ''}}?</h3>
		<v-btn
			class="mr-4 white--text"
			color="rgb(0, 160, 227)"
			@click="deleteFileClick"
		>
			{{txt.btn.yes}}
		</v-btn>
		<v-btn
			class="mr-4"
			color="secondary"
			@click="dialogConfirmDeleteFile=false"
		>
			{{txt.btn.no}}
		</v-btn>
		</div>
	</v-card>
	</v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
	name: 'FileList',
	data() {
		return {
			files: 'Files',
			fileList: [],
			selectedItem: 1,
			dialogConfirmDeleteFile: false,
			fileSelectedForDelete: null,
			txt: {
				messageToUser: '',
				noteFileLifetime: 'Note: All reports older than 7 days are automatically deleted.',
				deleteConfirmation: 'Are you sure you want to delete the file',
				btn: {
					yes: 'yes',
					no: 'no',
					refresh: 'refresh',
				},
				reports: 'Reports',
				downloadMessage: `You file is being prepared for download...
								Depending on the filesize it can take longer`,
				downloadError: 'Oops. Something went wrog, we can not provide the requested file.',
			},
			showDownloadMessage: false,
			showDownloadError: false,
		}
	},
	methods: {
		async downloadFile(file) {
			try {
				this.showDownloadMessage = true
				const values = {
					userName: this.$keycloak.userName,
					file,
				}
				const res = await axios({
					method: 'post',
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/profile/downloadFile`,
					data: values,
					responseType: 'blob',
				})
				// eslint-disable-next-line no-undef
				saveAs(new Blob([res.data]), file.filename)
				this.showDownloadMessage = false
			} catch (e) {
				this.showDownloadMessage = false
				this.showDownloadError = true
				// eslint-disable-next-line no-return-assign
				setTimeout(() => this.showDownloadError = false, 5000)
			}
		},
		async deleteFile(file) {
			this.dialogConfirmDeleteFile = true
			this.fileSelectedForDelete = file
		},
		async deleteFileClick() {
			const file = this.$data.fileSelectedForDelete
			try {
				const values = {
					userName: this.$keycloak.userName,
					file,
				}
				const res = await axios({
					method: 'delete',
					// eslint-disable-next-line no-undef
					url: `${config.baseAPIurl}/profile/file`,
					data: values,
				})
				this.txt.messageToUser = res.data.message
				await this.getFileListFromServer()
				setTimeout(() => this.$store.commit('unseenFiles'))
			} catch (e) {
				console.log(e)
			} finally {
				this.dialogConfirmDeleteFile = false
			}
		},

		async getFileListFromServer() {
			try {
				// eslint-disable-next-line no-undef
				const res = await axios.get(`${config.baseAPIurl}/profile/fileList`)
				this.fileList = res.data
				this.fileList.forEach((el) => {
					el.fileCreatedAt = `File created at: ${moment(el.fileCreatedAt).format('YYYY-MM-DD HH:mm:ss')}`
				})
				/* mark the file as seen */
				// eslint-disable-next-line no-undef
				await axios.put(`${config.baseAPIurl}/index/unseen-files`)
				setTimeout(() => this.$store.commit('unseenFiles'))
			} catch (e) {
				// TODO: handle it
				console.log(e)
			}
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getFileListFromServer()
		})
	},
}
</script>

<style>
.formEdit {
  padding: 25px;
  margin: 0;
  height: 100%;
  overflow: hidden;
}

.reloadButton{
	margin-top: 25px;
	margin-bottom: 25px;
}

.progressbarFileList{
	margin-top: 0px;
	padding-top: 0px;
}

.messageFileFetching{
	margin-bottom: 0px;
}

</style>
